import { CharityContent, CharityResponse } from "@/models/Content";
import { CharityConfig } from "@/models/www/Charity";
import { CharityResource } from "@/models/www/store/CharityState";
import charityService from "@/services/charity.service";
import contentService from "@/services/content.service";
import { useCharityStore } from "@/store/charity";
import { ref } from "vue";

const useCharity = () => {
    const charityConfig = ref<CharityConfig>();
    const charityStore = useCharityStore();

    const updateStateResources = (charityResources: CharityResponse[]) => {
        const resources = [] as CharityResource[];

        if (charityStore.getResources.every(r => !r.identifier)) {
            charityStore.getResources?.forEach(r => {
                r.identifier = charityResources.find(c => c.resourceCode === r.resourceCode)?.identifier ?? "";

                resources.push(r);
            });

            charityStore.setResources(resources);
        }
    }

    const getCharity = (): Promise<CharityConfig> => {
        return new Promise((resolve, reject) => {
            const promises: Promise<unknown>[] = [getAvailableCharity(), getCharityContent()];
            Promise.all(promises).then(([resources, content]) => {
                updateStateResources(resources as CharityResponse[]);
                charityConfig.value = new CharityConfig(content as CharityContent[], resources as CharityResponse[])
                resolve(charityConfig.value);
            }).catch((err) => reject(err))
        });
    }

    const getCharityContent = (): Promise<CharityContent[]> => {
        return new Promise((resolve, reject) => {
            contentService.getCharityContent().then((resp) => {
                resolve(resp);
            }).catch((err) => {
                reject(err);
            })
        })
    }

    const getAvailableCharity = (): Promise<CharityResponse[]> => {
        return new Promise((resolve, reject) => {
            charityService.getAvailableCharity().then((resp) => {
                resolve(resp);
            }).catch((err) => {
                reject(err);
            })
        })
    }

    return { getCharity, charityConfig }
}

export default useCharity;